import React, {useContext} from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

// darkColor / lightColor are optional per-skill overrides (hex, no #).
// When absent, icons render in their default brand colour.
function iconSrc(skill, isDark) {
  const themeColor = isDark ? skill.darkColor : skill.lightColor;
  if (skill.iconUrl) {
    return themeColor
      ? skill.iconUrl.replace("{color}", themeColor)
      : skill.iconUrl;
  }
  return themeColor
    ? `https://cdn.simpleicons.org/${skill.iconSlug}/${themeColor}`
    : `https://cdn.simpleicons.org/${skill.iconSlug}`;
}

export default function SoftwareSkill() {
  const {isDark} = useContext(StyleContext);
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {skillsSection.softwareSkills.map((skills, i) => {
            return (
              <li
                key={i}
                className="software-skill-inline"
                name={skills.skillName}
              >
                {skills.iconSlug || skills.iconUrl ? (
                  <img
                    src={iconSrc(skills, isDark)}
                    alt={skills.skillName}
                    style={{width: "48px", height: "48px"}}
                  />
                ) : (
                  <i className={skills.fontAwesomeClassname}></i>
                )}
                <p>{skills.skillName}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
